import { render, staticRenderFns } from "./commissions-notes-loader.vue?vue&type=template&id=0f9d4a1f"
import script from "./commissions-notes-loader.vue?vue&type=script&lang=ts"
export * from "./commissions-notes-loader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports